import Vue from "vue";
import ViewContract from "./ViewContract.vue";
import WebViewer from "../../components/WebViewer.vue";
import { Tabs, Tab } from 'vue-tabs-component';
import JsonViewer from 'vue-json-viewer';

Vue.component('tabs', Tabs);
Vue.component('tab', Tab);
Vue.component("web-viewer", WebViewer);
Vue.use(JsonViewer)

new Vue({
    el: "#page-container",
    components: {
        ViewContract,
    },
});


// WEBPACK FOOTER //
// ./Scripts/modules/view-contract/index.js